export function makeId(length) {
  let result = '';
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
  const charactersLength = characters.length;
  for (var i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength))
  }
  return result
}

export function debounce(fn, wait) {
  let timer
  return function (...args) {
    if (timer) clearTimeout(timer)
    const context = this
    timer = setTimeout(() => {
      fn.apply(context, args)
    }, wait)
  }
}

/**
 * Returns bytes converted to the bigger int number with or without unit
 *
 * @param {number} x Bytes to convert
 * @param {number} base Base multiplier used for conversion (e.g. MiB 1024, MB 1000)
 * @param {boolean} add_unit Output the result with the unit string
 * @returns {number, string} Converted bytes with or without unit
 */
export function niceBytes(x, base, add_unit = false) {
  const unit_names = {
    1000: ['bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
    // 1024: ['bytes', 'KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB'] // this is the correct unit names
    1024: ['bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
  }
  let l = 0, n = parseInt(x, 10) || 0
  while (n >= base && ++l) {
    n = n / base
  }
  const decimals = (n < 10 && l > 0) ? 2 : 1
  const value = Number(n.toFixed(decimals))
  const unit = ' ' + unit_names[base][l]
  return (add_unit) ? value + unit : value
}

export function splitFullName(fullName) {
  // Split the fullName string by the first space
  const [firstName, ...rest] = fullName.split(' ')

  // Join the remaining parts to form the surname
  const surname = rest.join(' ')

  return {
    firstName: firstName,
    surname: surname
  }
}

export function getBrowserLanguage() {
  const userLanguage = (navigator.languages && navigator.languages.length)
    ? navigator.languages[0]
    : navigator.language;

  const languageOnly = userLanguage.split(/[-_]/)[0] // Extract only the language code

  // Check for Dutch or Spanish, otherwise default to English
  if (languageOnly === 'nl') {
    return 'nl' // Dutch
  } else if (languageOnly === 'es') {
    return 'es' // Spanish
  } else {
    return 'en' // Default to English
  }
}

export function randomCelebName() {
  const celebrityNames = [
    'Michael Douglas',
    'Gordon Gekko',
    'Charlie Sheen',
    'Bud Fox',
    'Daryl Hannah',
    'Darien Taylor',
    'Martin Sheen',
    'Carl Fox',
    'Terence Stamp',
    'Sir Larry Wildman',
    'James Karen',
    'Hal Holbrook',
    'Lou Mannheim',
    'Sean Young',
    'Kate Gekko',
    'James Spader',
    'Roger Barnes'
  ];
  var randomIndex = parseInt(Math.random() * celebrityNames.length)
  return celebrityNames[randomIndex]
}

export function randomEmail(name) {
  const firsName = name.split(' ')[0]
  return firsName.toLowerCase() + '@example.com'
}

export function capitalize(s) {
  return String(s[0]).toUpperCase() + String(s).slice(1)
}

export function getHighContrastColor(color) {
  const rgbColor = hexToRgb(color)
  const grayscale = 0.299 * rgbColor.r + 0.587 * rgbColor.g + 0.114 * rgbColor.b
  const contrastColor = grayscale > 128 ? '#000000' : '#FFFFFF'

  return contrastColor
}

export function hexToRgb(color) {
  // Remove the hash if it exists
  const hex = color.replace(/^#/, '');

  // Parse the hex value into individual RGB components
  const bigint = parseInt(hex, 16)
  const r = (bigint >> 16) & 255
  const g = (bigint >> 8) & 255
  const b = bigint & 255

  return { r, g, b }
}

export function promptDownload(response) {
  const contentDisposition = response.headers['content-disposition']

  let filename = 'download.pdf'; // Default filename
  if (contentDisposition) {
    const match = contentDisposition.match(/filename="?([^";]+)"?/)
    if (match && match[1]) {
      filename = match[1] // Extract the actual filename
    }
  }

  const url = window.URL.createObjectURL(response.data)
  const a = document.createElement('a')
  a.href = url
  a.download = filename // Set the filename
  document.body.appendChild(a)
  a.click() // Trigger download
  document.body.removeChild(a)
  window.URL.revokeObjectURL(url) // Clean up
}

export function encodeQueryData(data) {
  var ret = []
  for (var d in data) {
    if (data[d]) {
      ret.push(encodeURIComponent(d) + "=" + encodeURIComponent(data[d]))
    }
  }
  return ret.join("&")
}

export function extensionFromMimeType(mimeType) {
  switch (mimeType) {
    case 'application/zip':
      return '.zip'

    case 'application/vnd.ms-excel':
      return '.xls'

    case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
      return '.xlsx'

    case 'text/csv':
      return '.csv'

    case 'application/xml':
      return '.xml'

    case 'application/pdf':
      return '.pdf'

    case 'application/vnd.oasis.ubl+xml':
      return '.ubl'
  }

  return '.bin'
}

export function getFileName(item) {
  let result = ''

  switch (item.subtype) {
    case 'bank':
      result = this.$gettext('Bank transactions')
      break

    case 'invoices':
      result = this.$gettext('Invoices')
      break

    case 'costs':
      result = this.$gettext('Costs')
      break

    case 'hours':
      result = this.$gettext('Hours')
      break

    case 'trips':
      result = this.$gettext('Trips')
      break

    case 'contacts':
      result = this.$gettext('Contacts')
      break

    default:
      result = item.subtype
  }

  if (item.filters) {
    const ignored_filters = [
      'option',
      'ordering',
      'extended',
      'activeView',
      'assignment_status',
      'rounding_precision',
      'sender_company'
    ]

    let is_company_included = false
    for (const [key, value] of Object.entries(item.filters)) {
      if (!key || !value || ignored_filters.includes(key)) {
        continue
      }

      result += ' '

      switch (key.toLowerCase()) {
        case 'owner_company':
        case 'company_profile':
          if (!is_company_included) {
            result += this.$gettext('from company') + ` ${value.name}`
            is_company_included = true
          }
          break

        case 'status':
          result += this.$gettext('with status') + ` ${value}`
          break

        case 'project':
          result += this.$gettext('in project') + ` ${value.name}`
          break

        case 'start_date':
          result += this.$gettext('starting at') + ` ${Date.parse(value).toLocaleDateString()}`
          break

        case 'end_date':
          result += this.$gettext('ending at') + ` ${Date.parse(value).toLocaleDateString()}`
          break

        default:
          break
      }
    }
  }

  result += extensionFromMimeType(item.mime_type)

  return result
}

export function getSecondsLeft(item) {
  const created = new Date(item.created).getTime()
  const now = Date.now()
  const expiresAt = created + item.activate_after_seconds * 1000
  const secondsLeft = Math.floor((expiresAt - now) / 1000)
  return secondsLeft > 0 ? secondsLeft : 0
}

/**
 * Adjust a color’s lightness and grayscale.
 *
 * - Lightness is adjusted *relatively*:
 *   - positive values move L toward white without clipping,
 *   - negative values move L toward black.
 *   Range: -1.0 to +1.0 (e.g. 0.3 = 30% closer to white).
 *
 * - Grayscale desaturates the color:
 *   - 0 = keep full saturation,
 *   - 1 = fully gray.
 *   If `perceptual` is true, blending is done against
 *   luminance gray (more natural to the eye).
 *
 * @param {string} hex - Hex color (#rgb or #rrggbb).
 * @param {Object} options
 * @param {number} [options.lightness=0] - Relative lightness shift (-1..1).
 * @param {number} [options.gray=0] - Grayscale factor (0..1).
 * @param {boolean} [options.perceptual=false] - Use perceptual grayscale.
 * @returns {string} Adjusted hex color (#rrggbb).
 */
export function adjustColor(hex, { lightness = 0, gray = 0, perceptual = false } = {}) {
  const clamp01 = (v) => Math.min(1, Math.max(0, v))

  // hex -> rgb
  hex = hex.replace(/^#/, '')
  if (hex.length === 3)
    hex = hex
      .split('')
      .map((c) => c + c)
      .join('')
  let r = parseInt(hex.slice(0, 2), 16),
    g = parseInt(hex.slice(2, 4), 16),
    b = parseInt(hex.slice(4, 6), 16)

  // rgb -> hsl
  r /= 255
  g /= 255
  b /= 255
  const max = Math.max(r, g, b),
    min = Math.min(r, g, b)
  let h = 0,
    s = 0,
    l = (max + min) / 2
  const d = max - min
  if (d) {
    s = l > 0.5 ? d / (2 - max - min) : d / (max + min)
    switch (max) {
      case r:
        h = (g - b) / d + (g < b ? 6 : 0)
        break
      case g:
        h = (b - r) / d + 2
        break
      default:
        h = (r - g) / d + 4
    }
    h /= 6
  }

  // --- relative lightness (no sudden whites) ---
  if (lightness >= 0) l = l + (1 - l) * lightness
  else l = l * (1 + lightness)
  l = clamp01(l)

  // --- desaturation toward gray ---
  s = clamp01(s * (1 - clamp01(gray)))

  // hsl -> rgb
  function hue2rgb(p, q, t) {
    if (t < 0) t += 1
    if (t > 1) t -= 1
    if (t < 1 / 6) return p + (q - p) * 6 * t
    if (t < 1 / 2) return q
    if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6
    return p
  }
  const q = l < 0.5 ? l * (1 + s) : l + s - l * s
  const p = 2 * l - q
  r = Math.round(hue2rgb(p, q, h + 1 / 3) * 255)
  g = Math.round(hue2rgb(p, q, h) * 255)
  b = Math.round(hue2rgb(p, q, h - 1 / 3) * 255)

  // --- optional perceptual gray blend ---
  if (perceptual && gray > 0) {
    const y = Math.round(0.2126 * r + 0.7152 * g + 0.0722 * b)
    r = Math.round(r + (y - r) * gray)
    g = Math.round(g + (y - g) * gray)
    b = Math.round(b + (y - b) * gray)
  }

  const to2 = (n) => n.toString(16).padStart(2, '0')
  return `#${to2(r)}${to2(g)}${to2(b)}`
}

export function bwFor(hexcolor) {
  // Remove # if present
  hexcolor = hexcolor.replace(/^#/, '');

  // Parse short hex (#abc → #aabbcc)
  if (hexcolor.length === 3) {
    hexcolor = hexcolor.split('').map(c => c + c).join('');
  }

  const r = parseInt(hexcolor.substr(0,2),16);
  const g = parseInt(hexcolor.substr(2,2),16);
  const b = parseInt(hexcolor.substr(4,2),16);

  // YIQ formula for perceived brightness
  const yiq = (r*299 + g*587 + b*114) / 1000;

  // Return black or white depending on brightness
  return (yiq >= 128) ? '#333333' : '#FFFFFF';
}